// import axios from "axios"
import EcdhKey, { generateEcdhKeyPair } from "../utils/ecdh"
import { AesCBCDecrypt, AesCBCEncrypt, buildExchangeKey, setEdchKeyLocal } from "../utils/secure"
import { getOpenApiExchangeUrl, getPresetKey } from "../utils/secure.config"

// 引入第三方axios库,iifeScript打包问题
// 使用原生 fetch API 重写异步请求函数
const sendRequestToOpenAPI = async (openApiUrl: string, encPublicKey: string, headers: any) => {
    const response = await fetch(openApiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ client_public_key: encPublicKey })
    });
    return response.json(); 
};

// 密钥协商
export async function exchangeKey(currenAppName?:string) {
    const [privateKeyHex, publicKeyHex] = await generateEcdhKeyPair()
    const PRSET_KEY = getPresetKey(currenAppName)
    const openApiUrl = await getOpenApiExchangeUrl(currenAppName)
    const encPublicKey = await AesCBCEncrypt(publicKeyHex, PRSET_KEY)
    const { randomField, headers } = await buildExchangeKey(PRSET_KEY, encPublicKey,currenAppName)
    // const response = await axios.post(openApiUrl, { client_public_key: encPublicKey }, { headers });
    const response = await sendRequestToOpenAPI(openApiUrl, encPublicKey, headers);
    console.log('exchangeKey response:', response);
    const serverPublicKey = await AesCBCDecrypt(response.data.server_public_key, PRSET_KEY);
    const ecdhKey = new EcdhKey(randomField.keyindent, privateKeyHex, serverPublicKey)
    await ecdhKey?.performKeyExchange()
    await setEdchKeyLocal(ecdhKey,currenAppName)
    console.log('exchangeKey :', { ecdhKey, encPublicKey, headers, randomField, serverPublicKey, publicKeyHex, privateKeyHex});
    return ecdhKey
  }
  